/**
 * Detects the Xceed Pro native shell by its UA marker. Module-level (not a
 * context read) so bridge components mounted above FeatureFlagProvider and the
 * auth render gate can use it.
 */
export const isWebViewUserAgent = (): boolean => /xceed-pro-app/i.test(globalThis.navigator?.userAgent ?? '');
